import styled from "styled-components"

const EventsItemImg = styled.div`
  &::before {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const EventsItemDate = styled.div`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const EventsItemTaxo = styled.div`
  display: flex;
  & > p {
    margin-right: 0.8vw;
    color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
  & > a {
    &::first-letter {
      text-transform: uppercase;
    }
    color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

export { EventsItemDate, EventsItemTaxo, EventsItemImg }
